import { ApisauceInstance, create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import { getPaymentAccessToken } from '../../../utils/PaymentStorageUtils';

import {
  ClientLoginWithCodeRequestType,
  ClientLoginWithCodeResponseType,
  RefreshAuthTokensRequestType,
  RefreshAuthTokensResponseType
} from './types';

import { PaymentsAuthAPIServiceTypes } from '.';

class PaymentsAuthAPIService implements PaymentsAuthAPIServiceTypes {
  api: ApisauceInstance;
  networkCallWithAPISauce: any;

  constructor(networkCallWithAPISauce: any) {
    this.api = create({
      baseURL: `${Config['PAYMENT_AUTHENTICATION_URL']}`
    });
    this.networkCallWithAPISauce = networkCallWithAPISauce;
  }

  onLogin(
    requestObject: ClientLoginWithCodeRequestType
  ): Promise<ClientLoginWithCodeResponseType> {
    return this.networkCallWithAPISauce(
      this.api,
      'login/v1/',
      requestObject,
      apiMethods.post
    );
  }

  getRefreshToken = (
    requestObject: RefreshAuthTokensRequestType
  ): Promise<RefreshAuthTokensResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `refresh_auth_tokens/v1/`,
      requestObject,
      apiMethods.post,
      {
        getAccessToken: () => getPaymentAccessToken()
      }
    );
  };
}

export { PaymentsAuthAPIService };
